export default "__VITE_ASSET__a6bee66d__"